import { useWorkspaceText } from './interface-copy';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { useConnections } from './use-connections';

export function ConnectionFeedback({
  connections,
}: {
  connections: ReturnType<typeof useConnections>;
}) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const failure = connections.failure;
  return (
    <Dialog open={Boolean(failure)} onOpenChange={(open) => !open && connections.dismissFailure()}>
      <DialogContent className="ws-connection-feedback">
        <DialogHeader>
          <DialogTitle>
            {uiRich('{value1} was not connected', { value1: failure?.item.name })}
          </DialogTitle>
          <DialogDescription>{failure?.detail}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <button type="button" className="company-secondary" onClick={connections.dismissFailure}>
            {uiText('Dismiss')}
          </button>
          {failure?.item.actions.connect.available && (
            <button
              type="button"
              className="company-primary"
              onClick={() => {
                const item = failure.item;
                connections.dismissFailure();
                connections.requestConnect(item);
              }}
            >
              {uiText('Try connecting again')}
            </button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
